<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
            
                <h3 class="text-center mb-5 mt-5">{{$store.getters.t('random_pets_or_projects_need_your_help')}}</h3>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-6 col-12" v-for="item in list">
                <!-- start .single-product -->
                <div class="product product--card product--card-medium d-flex" >
                    <div class="product__thumbnail">
                        <div v-if="!!item.avatar" class="product__thumbnail-image"
                             :style="'background-image: url(/storage' + item.avatar.path | convertImage('square') + ')'"></div>

                        <div v-else class="product__thumbnail-image"> No Image </div>



                        <div class="prod_btn">
                            <a :href="type === 'projects' ? '/projects/' + item.id : '/pets/' + item.id" class="transparent btn--sm btn--round">{{$store.getters.t('random_pets_or_projects_more_details')}}</a>
                        </div>
                    </div>
                    <div class="product-desc">
                        <a :href="type === 'projects' ? '/projects/' + item.id : '/pets/' + item.id" class="product_title">
                            <h4>{{item.name}}</h4>
                        </a>
                        <p class="product_description">{{item.ad_title}}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="pageCount > 1">
            <div class="col-md-12">
                <div class="pagination-area pull-right">
                    <nav class="navigation pagination" role="navigation">
                        <div class="nav-links">
                            <paginate
                                v-model="page"
                                :page-count="pageCount"
                                :click-handler="paginateClickCallback"
                                :prev-text="''"
                                :next-text="''"
                                :container-class="'className'"
                                :page-class="'page-numbers'"
                                :page-link-class="''"
                                :active-class="'current'"
                                :prev-class="'prev page-numbers'"
                                :prev-link-class="'lnr lnr-arrow-left'"
                                :next-class="'next page-numbers'"
                                :next-link-class="'lnr lnr-arrow-right'"
                            >
                            </paginate>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
        <!-- end /.row -->
    </div>
</template>

<script>
    export default {
        name: "RandomPetsOrProjectsComponent",
        data() {
            return {
                pageCount: 0,
                page: 1,
                list: []
            }
        },

        mounted() {
            this.getList();
        },
        props: ['type'],
        methods: {
            getList() {
                let self = this;


                let url = this.type === 'animals' ? '/catalog/pets' : '/catalog/projects'

                axios.get(url, {
                    params: {
                        page: self.page,
                        random: 1,
                        per_page: 4
                    }
                })
                    .then(response => {

                        const {
                                data: {
                                    data = [],
                                    extended_data: { success = false },
                                    ...rest
                                }
                        } = response

                        if (success) {
                            self.list = data;
                            self.pageCount = rest.last_page
                        } else {
                            alert('Произошла ошибка! Попробуйте перезагрузить страницу.');
                        }
                    })
                    .catch((error) => {

                    })
                    .then();

            },
            paginateClickCallback(pageNum) {
                this.page = pageNum;
                this.getList();
            },

        },
        watch: {
            type(){
                this.page = 1;
                this.getList()
            }

        }
    }
</script>

<style scoped>

</style>
